import CountUp from "react-countup";

const StatsCards = ({ stats, className }) => {
  return (
    <div
      className={`${
        className ?? "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
      } `}
    >
      {stats &&
        stats.length > 0 &&
        stats.map((stat, idx) => (
          <div
            key={idx}
            className={`rounded-xl border-2 ${stat.border} bg-white text-center p-6 shadow-sm`}
          >
            <div className={`text-3xl font-bold ${stat.color}`}>
              <CountUp end={stat.value} duration={1.5} />
            </div>
            <div className={`mt-1 text-sm font-medium ${stat.color}`}>
              {stat.label}
            </div>
          </div>
        ))}
    </div>
  );
};

export default StatsCards;
